import GoogleMapField from './GoogleMapField';

export default GoogleMapField;
